/**
 * Simple axios interceptor for token expiration handling
 */

import axios from 'axios';

let msalInstance = null;
let showToastCallback = null;

/**
 * Initialize the auth interceptor
 */
export const initAuthInterceptor = (instance, showToast) => {
  msalInstance = instance;
  showToastCallback = showToast;
};

/**
 * Setup axios interceptor to catch 401 errors
 */
export const setupAxiosInterceptor = () => {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        // Token expired
        if (showToastCallback) {
          showToastCallback('Your session has expired. Please login again.', 'warning');
        }
        
        // Redirect to login after a short delay
        setTimeout(() => {
          if (msalInstance) {
            msalInstance.logoutRedirect();
          }
        }, 2000);
      }
      return Promise.reject(error);
    }
  );
};
